import http from "../axios/axios-instance";
import {parseCertificates} from "../utils/utils";
import {sleep} from "../../utils/CommonUtils";

const checkServiceConnection = () => {
    return http.post("/ParsKitWebAPI/PK_ServiceConnection");
}

const setCryptoKey = (cryptoKey = {
    "pk_ipCryptokiType": 0,
    "pk_ipCryptoki": "parskey11.dll"
}) => {
    return http.post("/ParsKitWebAPI/PK_SetCryptoki", cryptoKey, {headers: {'Content-Type': 'text/plain'}})
}

const login = ({
                   pk_ipLoginType = 0,
                   pk_ipPincode,
                   pk_ipSlotId,
                   pk_ipUserType = 1
               }) => {
    return http.post("/ParsKitWebAPI/PK_Login", {
        pk_ipLoginType,
        pk_ipPincode,
        pk_ipSlotId,
        pk_ipUserType
    }, {headers: {'Content-Type': 'text/plain'}})
}
const logout = (slotId = 0) => {
    return http.post("/ParsKitWebAPI/PK_Logout", {pk_ipSlotId: slotId}, {headers: {'Content-Type': 'text/plain'}})
}

const selectCertificate = () => {
    return http.post("/ParsKitWebAPI/PK_SelectCertificate", {"pk_ipUsage": ""}, {headers: {'Content-Type': 'text/plain'}})
}

const getSlotCount = () => {
    return http.get("/ParsKitWebAPI/PK_GetSlotCount")
}

const checkToken = (slotId = 0) => {
    return http.post("/ParsKitWebAPI/PK_CheckToken", {pk_ipSlotId: slotId}, {headers: {'Content-Type': 'text/plain'}})
}

const getSlotInfo = (slotId = 0) => {
    return http.post("/ParsKitWebAPI/PK_GetSlotInfo", {pk_ipSlotId: slotId}, {headers: {'Content-Type': 'text/plain'}})
}

const getCerts = (slotId = 0) => {
    return http.post("/ParsKitWebAPI/PK_GetCerts", {pk_ipSlotId: slotId}, {headers: {'Content-Type': 'text/plain'}})
}
const getPublicKeyObject = (slotId, keyId) => {
    return http.post("/ParsKitWebAPI/PK_GetPublicObject", {
        pk_ipSlotID: slotId,
        pk_ipKeyID: keyId,
    }, {headers: {'Content-Type': 'text/plain'}});

}
const getPublicKeys = (slotId) => {
    return http.post("/ParsKitWebAPI/PK_GetTokenPubkeys", {
        pk_ipSlotId: slotId,
    }, {headers: {'Content-Type': 'text/plain'}});
}
const generateKey = (length = 2048, label = "test", extractable = true) => {
    setCryptoKey();
    return http.post("/ParsKitWebAPI/PK_GenKeyPair", {
        "pk_ipKeyLabel": label,
        "pk_ipKeyLen": length,
        "pk_ipX931GenKey": 0,
        "pk_ipExtractable": extractable ? 1 : 0,
        "pk_ipSensitive": 0,
        "pk_ipTokenFilterParams": ["", "", "", "", "", ""],
        "pk_ipLoginType": 1,
        "pk_ipLoginUserType": 1,
        "pk_ipLogoutAfterSign": 0
    }, {headers: {'Content-Type': 'text/plain'}});
};

const checkCertUsage = (certificate, usage) => {
    return http.post("/ParsKitWebAPI/PK_CheckCertUsage", {
        pk_ipCertificate: certificate,
        pk_ipUsage: usage
    }, {headers: {'Content-Type': 'text/plain'}})
}
const getCN = (certificate) => {
    return http.post("/ParsKitWebAPI/PK_GetCN", {
        pk_ipCertificate: certificate
    }, {headers: {'Content-Type': 'text/plain'}})
}
const getCertificates = async () => {
    let retryTimes = 4;
    await initializeParseKit();
    const getSlotCountResponse = await getSlotCount();
    let certificates = []
    if (getSlotCountResponse.data.pk_opSlotCount > 0) {
        for (let i = 0; i < getSlotCountResponse.data.pk_opSlotCount; i++) {
            const pkGetCertificateResponse = await getCerts(i);
            if (pkGetCertificateResponse.data.pk_opErrorCode === 0) {
                parseCertificates(pkGetCertificateResponse.data, certificates, i);
            } else {
                while (retryTimes > 0) {
                    await initializeParseKit();
                    const pkGetCertificateResponse = await getCerts(i);
                    if (pkGetCertificateResponse.data.pk_opErrorCode === 0) {
                        parseCertificates(pkGetCertificateResponse.data, certificates, i);
                        break;
                    }
                    await sleep(500)
                    retryTimes -= 1;
                }

            }
        }
    }
    return certificates;
}
const getTokens = async () => {
    let retryTimes = 4;
    await initializeParseKit();
    const getSlotCountResponse = await getSlotCount();
    let tokens = []
    if (getSlotCountResponse.data.pk_opSlotCount > 0) {
        for (let i = 0; i < getSlotCountResponse.data.pk_opSlotCount; i++) {
            const getTokenInfoResponse = await getSlotInfo(i);
            if (getTokenInfoResponse.data.pk_opErrorCode === 0) {
                tokens.push({...getTokenInfoResponse.data, slotId: i});
            } else {
                while (retryTimes > 0) {
                    await initializeParseKit();
                    const pkGetCertificateResponse = await getCerts(i);
                    if (pkGetCertificateResponse.data.pk_opErrorCode === 0) {
                        tokens.push({...getTokenInfoResponse.data, slotId: i});
                        break;
                    }
                    await sleep(500)
                    retryTimes -= 1;
                }

            }
        }
    }
    return tokens;
}

async function getTokenNames() {
    const [firstResponse, secondResponse, thirdResponse] = await Promise.all([
        checkServiceConnection(),
        setCryptoKey(),
        getSlotCount()
    ])
    let tokens = []
    if (thirdResponse.data.pk_opErrorCode === 0 && thirdResponse.data.pk_opSlotCount > 0) {

        const [checkTokenResponse] = await Promise.all([checkToken()])

        if (checkTokenResponse.data.pk_opErrorCode === 0 && checkTokenResponse.data.pk_opPresent === 1) {

            const [getSlotInfoResponse] = await Promise.all([getSlotInfo()])

            if (getSlotInfoResponse.data.pk_opErrorCode === 0) {

                tokens.push(getSlotInfoResponse.data.pk_opLabel)

                return tokens;
            }
            return null;
        }
        return null;
    }
    return null;
}

async function signDocument(tbs, certificate = null) {
    const [firstResponse, secondResponse, thirdResponse, signResponse] = await Promise.all([
        checkServiceConnection(),
        setCryptoKey(),
        setSignMech(1),
        signGUI(tbs, 3, certificate)

    ])
    return signResponse;
}

async function initializeAndSelectCertificate() {
    const [firstResponse, secondResponse, selectCertificateResponse] = await Promise.all([
        checkServiceConnection(),
        setCryptoKey(),
        selectCertificate()

    ])
    return selectCertificateResponse;


}

const generateCSR = (keyId = "",subjects = [],altSubjects = [],keyLength = 2048) => {
    const data = {
        "pk_ipKeyId": keyId,
        "pk_ipProfile": subjects, //3-Sha256
        "pk_ipX931GenKey": 1, //1- PK_RSA_PKCS
        "pk_ipKeyLen": keyLength,
        "pk_ipExtractable": 0,
        pk_ipSubAltName : altSubjects,
        "pk_ipTokenFilterParams": ["", "", "", "", "", ""],
        "pk_ipLoginType": 1,
        "pk_ipLoginUserType": 1,
        "pk_ipLogoutAfterSign": 0
    }
    return http.post("/ParsKitWebAPI/PK_GenCSR",data , {headers: {'Content-Type': 'text/plain'}})
}
const setSignMech = (signatureFormat = 2,hashAlg = 3) => {

    return http.post("/ParsKitWebAPI/PK_SetSignMech", {
        "pk_ipSignatureFormat": signatureFormat,
        "pk_ipSignHashAlg": hashAlg, //3-Sha256
        "pk_ipSignMechanism": 1, //1- PK_RSA_PKCS
        "pk_ipSaltLen": 0,
        "pk_ipMgf": 0
    }, {headers: {'Content-Type': 'text/plain'}})
}
const signGUI = (tbs, tbsType = 4, certificate = null) => {
    return http.post("/ParsKitWebAPI/PK_Sign", {
        "pk_ipSignMethodType": 1,
        "pk_ipLogoutAfterSign": 1,
        "pk_ipTokenFilterParams": certificate !== null ? ["1", "1", "1", certificate, ""] : ["0", "1", "1", "1", "", "", ""],
        "pk_ipResetSignMechFlag": 0,
        "pk_ipTbsType": tbsType,
        "pk_ipTbsHashAlg": 0,
        "pk_ipTbs": tbs,
        "pk_ipUsage": "KeyUsage::C=F,DIGITAL_SIGNATURE=F,NON_REPUDIATION=F,KEY_ENCIPHERMENT=F,DATA_ENCIPHERMENT=F,KEY_AGREEMENT=F,KEY_CERT_SIGN=F,CRL_SIGN=F,ENCIPHER_ONLY=F,DECIPHER_ONLY=F;ExtendedKeyUsage::C=F,SERVER_AUTH=F,CLIENT_AUTH=F,CODE_SIGN=F,EMAIL_PROTECTION=F,TIME_STAMPING=F,OCSP_SIGN=F,SMART_CARD_LOGIN=F",
        "pk_ipUserType": 1,
        "pk_ipSignerKeyId": 0,
        "pk_ipPL": "2707385e81031268ZCwN9315cd23ad1c"
    }, {headers: {'Content-Type': 'text/plain'}})
}
const signWithoutGUIRequest = (tbs, tbsType = 3, certificate = null, keyId) => {
    return http.post("/ParsKitWebAPI/PK_Sign", {
        "pk_ipSignMethodType": 0,
        "pk_ipLogoutAfterSign": 0,
        "pk_ipTokenFilterParams": ["0", "1", "1", "1", "", "", ""],
        "pk_ipResetSignMechFlag": 0,
        "pk_ipTbsType": tbsType,
        "pk_ipTbsHashAlg": 0,
        "pk_ipTbs": tbs,
        "pk_ipUsage": "KeyUsage::C=F,DIGITAL_SIGNATURE=F,NON_REPUDIATION=F,KEY_ENCIPHERMENT=F,DATA_ENCIPHERMENT=F,KEY_AGREEMENT=F,KEY_CERT_SIGN=F,CRL_SIGN=F,ENCIPHER_ONLY=F,DECIPHER_ONLY=F;ExtendedKeyUsage::C=F,SERVER_AUTH=F,CLIENT_AUTH=F,CODE_SIGN=F,EMAIL_PROTECTION=F,TIME_STAMPING=F,OCSP_SIGN=F,SMART_CARD_LOGIN=F",
        "pk_ipUserType": 1,
        "pk_ipSignerKeyId": keyId,
        "pk_ipPL": "2707385e81031268ZCwN9315cd23ad1c"
    }, {headers: {'Content-Type': 'text/plain'}})
}

function initializeWithParskeyAndSign(tbs) {
    checkServiceConnection().then(function (response) {
        if (response.data.pk_opErrorCode === 0) {
            setCryptoKey().then(function () {
                setSignMech().then(function () {
                    signGUI(tbs).then(function (response2) {
                        if (response2.data.pk_opErrorCode === 0) {
                            return response2.data.pk_opSignature;
                        } else {
                            return null;
                        }
                    });
                    return null;
                }).catch(function (error) {
                    return null;
                });
            });
        } else {
            return null;
        }
    }).catch(function (error) {
        return null;
    });
    return null;
}

const initializeParseKit = async () => {
    const [firstResponse, secondResponse, thirdResponse] = await Promise.all([
        checkServiceConnection(),
        setCryptoKey(),
        setSignMech(1),
    ])
}
export {
    checkServiceConnection,
    setCryptoKey,
    selectCertificate,
    signGUI,
    initializeParseKit,
    initializeWithParskeyAndSign,
    setSignMech,
    getSlotCount,
    getSlotInfo,
    checkToken,
    getTokenNames,
    getTokens,
    signDocument,
    checkCertUsage,
    getCN,
    getCerts,
    getCertificates,
    initializeAndSelectCertificate,
    signWithoutGUIRequest,
    login,
    generateKey,
    getPublicKeyObject,
    getPublicKeys,
    generateCSR
};
